import { LoaderCircle } from "lucide-react";
import { ASSETS } from "@zkresistor/client";

export function Loading({ label }: { label: string }) {
  return (
    <p className="loading">
      <LoaderCircle size={18} />
      {label}
    </p>
  );
}

export function Boot() {
  return (
    <div className="boot">
      <img src={ASSETS.zkresistor} alt="" />
      <LoaderCircle />
    </div>
  );
}

export function BootFailure({ error }: { error: string }) {
  return (
    <div className="boot failure">
      <img src={ASSETS.zkresistor} alt="" />
      <strong>Unable to start ZKResistor</strong>
      <span>{error}</span>
    </div>
  );
}
